export default async function (store) {
  if (!store.getters['auth/isLoggedIn']) {
    return
  }
  if (!store.getters['auth/hasModule'].advertisements) {
    return
  }
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => {
      store.dispatch('advertisements/updateAdvertisements')
    }, {
      timeout: 5000,
    })
  } else {
    store.dispatch('advertisements/updateAdvertisements')
  }
}
